import React from "react";
import { Link, NavLink } from "react-router-dom";
import ImageControl from "../common/ImageControl";

function Logo({ site_settings }) {
  return (
    <>
      <div className="logo">
        <a
          href="/"
        >
          {site_settings && (
            <ImageControl folder="images" src={site_settings.site_logo} />
          )}
        </a>
      </div>
    </>
  );
}

export default Logo;
